<template>
  <form 
    class="zk-form"
    :class="[ labelPosition ? 'zk-form--label-' + labelPosition : '', { 'zk-form--inline': inline } ]"
    :action="action"
    :method="method"
    >
    <slot></slot>
  </form>
</template>
<script>
  export default {
    name: 'ZkForm',
    componentName: 'form',
    props: {
      action: {
        type: String,
        default: null
      },
      method: {
        type: String,
        default: null
      },
      model: Object,
      rules: Object,
      labelPosition: String,
      labelWidth: String,
      labelSuffix: {
        type: String,
        default: ''
      },
      inline: Boolean
    },
    data() {
      return {
        fields: {},
        fieldLength: 0
      }
    },
    created() {
      this.$on('zk.form.addField', (field) => {
        this.fields[field.prop] = field
        this.fieldLength++
      })
      /* istanbul ignore next */
      this.$on('zk.form.removeField', (field) => {
        delete this.fields[field.prop]
        this.fieldLength--
      })
    },
    methods: {
      resetFields() {
        for (let prop in this.fields) {
          let field = this.fields[prop]
          field.resetField()
        }
      },
      validate(callback) {
        var count = 0
        var valid = true
        for (let prop in this.fields) {
          let field = this.fields[prop]
          field.validate('', errors => {
            if (errors) {
              valid = false
            }

            if (++count === this.fieldLength) {
              callback(valid)
            }
          })
        }
      },
      submit() {
        if (this.action) {
          this.$el.submit()
        }
      },
      validateField(prop, cb) {
        var field = this.fields[prop]
        if (!field) { throw new Error('must call validateField with valid prop string!') }

        field.validate('', cb)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// form.vue?05969075